var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCancelInverted = function SvgCancelInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1875F0",
    fillRule: "nonzero",
    d: "M15 19.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-1.5a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1875F0",
    d: "M12 13.06L13.06 12l4.95 4.95-1.06 1.06z"
  }))));
};
export default SvgCancelInverted;